import { createContext, useContext } from "react";
import { DEFAULT_HOVER_MODE_VISIBLE_IN_TIME } from "./constants";
/** @internal */
var noop = function () {
    // do nothing
};
/** @internal */
var context = createContext({
    visibleInTime: DEFAULT_HOVER_MODE_VISIBLE_IN_TIME,
    enableHoverMode: noop,
    disableHoverMode: noop,
    startDisableTimer: noop,
});
/**
 * @internal
 * @remarks \@since 2.8.0
 */
export var HoverModeContextProvider = context.Provider;
/**
 * Gets the {@link HoverModeContext} which allows you implement hover mode
 * functionality for any component. This is mostly an internal hook since
 * everything you need will be available in the {@link useHoverMode} hook.
 *
 * @internal
 * @remarks \@since 2.8.0
 * @returns The {@link HoverModeContext}
 */
export function useHoverModeContext() {
    return useContext(context);
}
//# sourceMappingURL=useHoverModeContext.js.map